module.exports = __webpack_public_path__ + "static/media/logo-dark.e952c553.png";